export const actions = {
  set: 'SET::MAXLIBRARYIMAGES'
}

export const setMaxLibraryImages = maxLibraryImages => ({ type: actions.set, maxLibraryImages: maxLibraryImages })
export const getmaxLibraryImages = state => state.maxLibraryImages

export default actions